const FOCUSABLE_SELECTOR = "a, button, input, [tabindex]";
const CLONE_CLASS = "glide__slide--clone";
const SLIDE_CLASS = ".glide__slide";
function setFocusableState(container, isFocusable) {
    const focusables = container.querySelectorAll(FOCUSABLE_SELECTOR);
    focusables.forEach((el) => {
        el.setAttribute("tabindex", isFocusable ? "0" : "-1");
    });
    container.setAttribute("aria-hidden", isFocusable ? "false" : "true");
}
function getVisibleIndices(index, perView, totalSlides) {
    const indices = new Set();
    for (let i = 0; i < perView; i++) {
        indices.add((index + i) % totalSlides);
    }
    return indices;
}
export function updateGlideSlideFocusables(glide, sliderContainer) {
    var _a;
    const allSlides = Array.from(sliderContainer.querySelectorAll(SLIDE_CLASS));
    const originalSlides = allSlides.filter((slide) => !slide.classList.contains(CLONE_CLASS));
    const cloneSlides = allSlides.filter((slide) => slide.classList.contains(CLONE_CLASS));
    const index = glide.index;
    const perView = (_a = glide.settings.perView) !== null && _a !== void 0 ? _a : 1;
    const visibleIndices = getVisibleIndices(index, perView, originalSlides.length);
    originalSlides.forEach((slide, i) => {
        setFocusableState(slide, visibleIndices.has(i));
    });
    cloneSlides.forEach((clone) => {
        setFocusableState(clone, false);
    });
}
export function bindGlideAccessibility(glide, sliderContainer) {
    glide.on(["mount.after", "run.after"], () => {
        updateGlideSlideFocusables(glide, sliderContainer);
    });
}
